const insightsAndTipsCodes = {
    TUNABILITY: 'tunability',
    SKU: 'sku',
    EG002: 'EG002',
    EG004: 'EG004',
    SHORT_SESSION: 'short_session',
    FREQUENT_LIMITATION: 'frequent_limitation',
    AVERAGE_PUFFS: 'average_puffs',
    AVERAGE_DURATION: 'average_duration',
    TIMES_TUNED: 'times_tuned',
    RANGE_PROFILE: 'range_profile',
} as const;

export default insightsAndTipsCodes;
